import employeeReducer from "./reducers";
export { default as employeeTypes } from "./types";
export { default as employeeOperations } from "./operations";
export { default as employeeActions } from "./actions";
export default employeeReducer;
